export enum AddUserUpdateInputNames {
  DATE = 'publishedDate',
  TITLE = 'title',
  CONTENT = 'description',
  MEDIA = 'media',
  SEND_OPTIONS_PAGE = 'sendOptionsPage',
  SEND_OPTIONS_EMAIL = 'sendOptionsEmail',
  SEND_OPTIONS_FACEBOOK = 'sendOptionsFacebook',
  SEND_OPTIONS_TWITTER = 'sendOptionsTwitter',
}
